import i18n from 'i18next';
import {ShadowType} from '../../../../incase-domain/common/elementShadow';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestion} from '../../../../incase-domain/elements/question/question';
import {IPresentationTheme, QuestionElement} from '../../../../incase-domain/presentationTheme';
import {getSelectedThemeFont, themeElementFrame} from './themeStyle';

export const THEME_QUESTION_PREVIEW_ID = 'presentation-theme-question-preview';

export function buildThemeQuestionPreviewElement(presentationTheme: IPresentationTheme, questionTheme?: QuestionElement): IElementQuestion {
    const theme = questionTheme ?? presentationTheme.elementStyles?.questionElement;
    const selectedFont = theme?.fontFamily || getSelectedThemeFont(presentationTheme);

    const answerLabel = i18n.t('presEditPage.editSidebar.elements.initialStates.answer');
    const answers = [
        {
            text: `${answerLabel} 1`,
            type: 'correct' as const,
            comment: i18n.t('presEditPage.editSidebar.elements.initialStates.yesNoQuestionComment'),
        },
        {
            text: `${answerLabel} 2`,
            type: 'incorrect' as const,
            comment: '',
        },
        {
            text: `${answerLabel} 3`,
            type: 'debatable' as const,
            comment: '',
        },
    ];

    return {
        ...themeElementFrame(THEME_QUESTION_PREVIEW_ID, ELEMENT.QUESTION, selectedFont),
        type: ELEMENT.QUESTION,
        question: i18n.t('presEditPage.editSidebar.elements.initialStates.question'),
        answers,
        correctAnswers: [0],
        singleCorrect: false,
        isDebatable: true,
        haveTryButton: true,
        tryLabel: 'Confirm',
        showAllComments: false,
        writeAnswerIndices: true,
        showInReport: true,
        fitContent: true,
        fontSize: theme?.answerFontSize?.value ?? 1.2,
        questionFontSize: theme?.questionFontSize?.value ?? 1.2,
        commentFontSize: theme?.commentFontSize?.value ?? 1.2,
        questionBackgroundColor: theme?.questionBackgroundColor,
        questionBackgroundBorderRadius: theme?.questionBackgroundBorderRadius,
        questionTextAlign: theme?.questionTextAlign,
        correctColor: theme?.correctColor,
        incorrectColor: theme?.incorrectColor,
        debatableColor: theme?.debatableColor,
        correctCommentColor: theme?.correctCommentColor,
        incorrectCommentColor: theme?.incorrectCommentColor,
        debatableCommentColor: theme?.debatableCommentColor,
        borderRadius: theme?.borderRadius,
        boxShadow: theme?.boxShadow ?? ShadowType.MEDIUM,
    };
}
